import { connect } from 'react-redux';
import AgreementDocument from './AgreementDocument';

const mapStateToProps = (state) => {
  return { user: state.userInfo.user, isAdmin: state.login.isAdmin };
};

export default connect(mapStateToProps)(AgreementDocument);
